import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AddressTitleService } from 'src/app/Service/AddressTitle/AddressTitle.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';


@Component({
  selector: 'app-CutomerView',
  templateUrl: './CutomerView.component.html',
  styleUrls: ['./CutomerView.component.scss']
})
export class CutomerViewComponent implements OnInit {

  @Input() inner_customer_id:number=0

  Token:String=""
  EditRecord:Number
  Edit_Customer_Record:Customer_Interface=Empty_Customer_Interface()

  constructor(
    private province_Service:ProvinceService,
    private Alerify:AlertifyService,

    private FeildActivity_Service:FeildActivityService,
    private Customer_Service:CustomerService,
    private AddressTitle_Service:AddressTitleService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Read_Address_Title()


    this.EdCustomer=new FormGroup({
      id :new FormControl(0),
      Code:new FormControl(null),
      Foreign:new FormControl("0"),
      ShenasehMeli:new FormControl(null),
      Name:new FormControl(null,Validators.required),
      ProvinceId:new FormControl("0"),
      CityId:new FormControl("0"),
      FeildActivity:new FormControl("0"),
      ShomarehSabt:new FormControl(null,Validators.pattern('^[0-9]{11}$')),
      CodeEghtesadi:new FormControl(null,Validators.pattern('^[0-9]{12}$')),
      CodeMeli:new FormControl(null,Validators.pattern('^[0-9]{9}$')),

      ModirAmelName:new FormControl(null),
      ModirAmelMobile:new FormControl(null),
      //ModirAmelMobile:new FormControl(null,Validators.pattern('^[0-9]{10}$')),
      ModirAmelTel:new FormControl(null),
      ModirAmelDakheli:new FormControl(null),
      ModirAmelEmail:new FormControl(null,Validators.email),
    })

    this.RabetMasolCustomer=new FormGroup({
      id :new FormControl(),
      FName:new FormControl(null,Validators.required),
      LName:new FormControl(null,Validators.required),
      Sex:new FormControl("1",Validators.required),
      Semat:new FormControl(null,Validators.required),
      Email:new FormControl('',Validators.email),
      Mobile:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      majaziMobile:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      jaygozinMiblie:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      Tel:new FormControl(''),
      Type:new FormControl('0'),
      Dakheli:new FormControl(''),
      Dsc:new FormControl(null),

    })

    this.AddressCustomer=new FormGroup({
      id :new FormControl(),
      title_id:new FormControl("0"),
      address:new FormControl(null),
      codepost:new FormControl(null,Validators.required),
      sandoghpost:new FormControl(null),
      pishShomareh:new FormControl(null),
      certificateAddress:new FormControl(null,[Validators.required,Validators.maxLength(50)]),
      Tel:new FormControl(null),
      Email:new FormControl('',Validators.email),
      Dakheli:new FormControl(null),
      Fax:new FormControl(null),
      Dsc:new FormControl(null),
    })

  }

  ReadData_Initial_Status:boolean=false
  ReadData_Initial(){

    if(this.inner_customer_id==0)
      this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    else
      this.EditRecord = this.inner_customer_id

    this.Customer_Service.GetSingle(this.Token,this.EditRecord).subscribe(
      data=>{
        this.DataList_Address=data['address']
        this.DataList_KarshnasMasol=data['karshnasMasol']
        this.RabetMasolCustomer_FeildActivity=data['fieldActivity']

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Dakhli=[]

          for (let itemDetail of item.dakhli_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Dakhli.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

          }

          item.dakhli_temp='-1'
        }

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Email=[]

            for (let itemDetail of item.email_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Email.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

            }
          item.email_temp='-1'
        }

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Tel=[]

            for (let itemDetail of item.tel_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Tel.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

            }
          item.tel_temp='-1'
        }

        for(let item of this.DataList_Address)
        {
          item.tel=[]

          for (let itemDetail of item.tel_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.tel.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

          }

          item.tel_temp='-1'
        }

        for(let item of this.DataList_Address)
        {
          item.email=[]

          for (let itemDetail of item.email_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.email.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

          }

          item.email_temp='-1'
        }

        this.Edit_Customer_Record=data['model']
        this.get_Form_Code().setValue(this.Edit_Customer_Record.code)
        this.get_Form_Name().setValue(this.Edit_Customer_Record.name)
        this.get_Form_ShenasehMeli().setValue(this.Edit_Customer_Record.shenasehMeli)

        if(this.Edit_Customer_Record.foreign==false)
          this.get_Form_Foreign().setValue("0")
        else
          this.get_Form_Foreign().setValue("1")

        this.get_Form_CodeEghtesadi().setValue(this.Edit_Customer_Record.codeEghtesadi)
        this.get_Form_ShomarehSabt().setValue(this.Edit_Customer_Record.shomarehSabt)
        this.get_Form_CodeMeli().setValue(this.Edit_Customer_Record.codeMeli)

        this.get_Form_ModirAmelName().setValue(this.Edit_Customer_Record.modirAmelName)
        this.get_Form_ModirAmelMobile().setValue(this.Edit_Customer_Record.modirAmelMobile)
        this.get_Form_ModirAmelTel().setValue(this.Edit_Customer_Record.modirAmelTel)
        this.get_Form_ModirAmelDakheli().setValue(this.Edit_Customer_Record.modirAmelDakheli)
        this.get_Form_ModirAmelEmail().setValue(this.Edit_Customer_Record.modirAmelEmail)
        this.get_Form_ProvinceId().setValue(this.Edit_Customer_Record.province_id)
        //this.get_Form_FeildActivity().setValue(this.Edit_Customer_Record.feildActivity_id)
        this.Read_Service_Province(this.Edit_Customer_Record.province_id)
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region FeildActivity

  DataList_FeildActivity:Array<FeildActivity_Interface>=[]
  ReadData_FeildActivity(){
      this.FeildActivity_Service.GetRecord(this.Token).subscribe(
        data=>{
          this.DataList_FeildActivity=data
          this.ReadData_Initial()
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
  }

  RabetMasolCustomer_FeildActivity:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_FeildActivity(){

      var Exited:boolean=false
      for  (let item of this.RabetMasolCustomer_FeildActivity)
      {
        if(item.id==Number(this.get_Form_FeildActivity().value))
        {
          Exited=true;
          break
        }
      }

      if(this.RabetMasolCustomer_FeildActivity.length==3)
      {
        this.Alerify.ErrorMessage("No more than 3 fields of activity can be registered.")
      }
      else if(Exited)
      {
        this.Alerify.ErrorMessage("The field of activity already exists in the list.")
      }
      else
      {
        var temp:General_Interface=Empty_General_Interface()
        temp.id = Number(this.get_Form_FeildActivity().value)
        temp.title=this.Get_Title_FeildActivity(temp.id)
        this.RabetMasolCustomer_FeildActivity.push(temp)


        this.get_Form_FeildActivity().setValue("0")
        this.Alerify.SuccessMessage("The field of activity was added to the list.")
      }
  }

  RabetMasolCustomer_FeildActivity_Delete(id){
      this.RabetMasolCustomer_FeildActivity.splice(id,1)
      this.Alerify.SuccessMessage("The field of activity was removed from the list.")
  }

  Get_Title_FeildActivity(id:Number)
    {
      for(let item of this.DataList_FeildActivity)
      {
        if(item.id==id)
        {
          return item.title
        }
      }
      return "";
  }

  //#endregion

  //#region  Form Edit

  EdCustomer:FormGroup;

  get_Form_id(){
    return this.EdCustomer.get('id') as FormControl;
  }

  
  get_Form_Foreign(){
    return this.EdCustomer.get('Foreign') as FormControl;
  }

  get_Form_Code(){
    return this.EdCustomer.get('Code') as FormControl;
  }

  get_Form_ShenasehMeli(){
    return this.EdCustomer.get('ShenasehMeli') as FormControl;
  }

  get_Form_Name(){
    return this.EdCustomer.get('Name') as FormControl;
  }

  get_Form_ProvinceId(){
    return this.EdCustomer.get('ProvinceId') as FormControl;
  }

  get_Form_CityId(){
    return this.EdCustomer.get('CityId') as FormControl;
  }

  get_Form_FeildActivity(){
    return this.EdCustomer.get('FeildActivity') as FormControl;
  }

  get_Form_ShomarehSabt(){
    return this.EdCustomer.get('ShomarehSabt') as FormControl;
  }

  get_Form_CodeEghtesadi(){
    return this.EdCustomer.get('CodeEghtesadi') as FormControl;
  }

  get_Form_CodeMeli(){
    return this.EdCustomer.get('CodeMeli') as FormControl;
  }

  get_Form_ModirAmelName(){
    return this.EdCustomer.get('ModirAmelName') as FormControl;
  }

  get_Form_ModirAmelMobile(){
    return this.EdCustomer.get('ModirAmelMobile') as FormControl;
  }

  get_Form_ModirAmelTel(){
    return this.EdCustomer.get('ModirAmelTel') as FormControl;
  }

  get_Form_ModirAmelDakheli(){
    return this.EdCustomer.get('ModirAmelDakheli') as FormControl;
  }

  get_Form_ModirAmelEmail(){
    return this.EdCustomer.get('ModirAmelEmail') as FormControl;
  }

  //#endregion

  //#region Province

  DataList_Province:Array<General_Interface>=[]
  DataList_City:Array<General_Interface>=[]

  Read_Service_Province(id:string){
    this.province_Service.GetRecord(id,this.Token).subscribe(
      data=>{
        if(id=="")
        {
          this.DataList_Province=data
          this.ReadData_FeildActivity()
        }
        else{
          this.DataList_City=data
          if(!this.ReadData_Initial_Status)
          {
            this.ReadData_Initial_Status=true
            this.get_Form_CityId().setValue(this.Edit_Customer_Record.city_id)
          }

        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ProvinceChange(){
    if(this.get_Form_ProvinceId().value=="0")
    {
      this.DataList_City=[]
    }
    else{
      this.get_Form_CityId().setValue("0")
      this.Read_Service_Province(this.get_Form_ProvinceId().value)
    }
  }


  //#endregion

  //#region Responsible contact form

  RabetMasolCustomer:FormGroup;

  get_Form_RabetMasol_FName(){
    return this.RabetMasolCustomer.get('FName') as FormControl;
  }

  get_Form_RabetMasol_LName(){
    return this.RabetMasolCustomer.get('LName') as FormControl;
  }

  get_Form_RabetMasol_Sex(){
    return this.RabetMasolCustomer.get('Sex') as FormControl;
  }

  get_Form_RabetMasol_Semat(){
    return this.RabetMasolCustomer.get('Semat') as FormControl;
  }

  get_Form_RabetMasol_Mobile(){
    return this.RabetMasolCustomer.get('Mobile') as FormControl;
  }

  get_Form_RabetMasol_majaziMobile(){
    return this.RabetMasolCustomer.get('majaziMobile') as FormControl;
  }

  get_Form_RabetMasol_jaygozinMiblie(){
    return this.RabetMasolCustomer.get('jaygozinMiblie') as FormControl;
  }

  get_Form_RabetMasol_Tel(){
    return this.RabetMasolCustomer.get('Tel') as FormControl;
  }

  get_Form_RabetMasol_Id(){
    return this.RabetMasolCustomer.get('id') as FormControl;
  }

  get_Form_RabetMasol_Dakheli(){
    return this.RabetMasolCustomer.get('Dakheli') as FormControl;
  }

  get_Form_RabetMasol_Email(){
    return this.RabetMasolCustomer.get('Email') as FormControl;
  }

  get_Form_RabetMasol_Dsc(){
    return this.RabetMasolCustomer.get('Dsc') as FormControl;
  }

  get_Form_RabetMasol_Type(){
    return this.RabetMasolCustomer.get('Type') as FormControl;
  }

  //#endregion

  //#region Responsible technician
  RabetMasolCustomer_Email:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_Email(){

    var Exited:boolean=false
    for  (let item of this.RabetMasolCustomer_Email)
    {
      if(item.title==this.get_Form_RabetMasol_Email().value)
      {
        Exited=true;
        break
      }
    }

    if(this.RabetMasolCustomer_Email.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 email addresses can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The email address already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_RabetMasol_Email().value
      this.RabetMasolCustomer_Email.push(temp)


      this.get_Form_RabetMasol_Email().setValue("")
      this.Alerify.SuccessMessage("The email address was added to the list.")
    }
  }

  RabetMasolCustomer_Email_Delete(id){
    this.RabetMasolCustomer_Email.splice(id,1)
    this.Alerify.SuccessMessage("The email address was removed from the list.")
  }


  RabetMasolCustomer_Dakheli:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_Dakheli(){

    var Exited:boolean=false
    for  (let item of this.RabetMasolCustomer_Dakheli)
    {
      if(item.title==this.get_Form_RabetMasol_Dakheli().value)
      {
        Exited=true;
        break
      }
    }


    if(this.RabetMasolCustomer_Dakheli.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 extension numbers can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The extension number already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_RabetMasol_Dakheli().value
      this.RabetMasolCustomer_Dakheli.push(temp)
      this.get_Form_RabetMasol_Dakheli().setValue("")

      this.Alerify.SuccessMessage("The extension number was added to the list.")
    }
  }
  RabetMasolCustomer_Dakheli_Delete(id){
    this.RabetMasolCustomer_Dakheli.splice(id,1)
    this.Alerify.SuccessMessage("The extension number was removed from the list.")
  }


  RabetMasolCustomer_Tel:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_Tel(){

    var Exited:boolean=false
    for  (let item of this.RabetMasolCustomer_Tel)
    {
      if(item.title==this.get_Form_RabetMasol_Tel().value)
      {
        Exited=true;
        break
      }
    }


    if(this.RabetMasolCustomer_Tel.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 phone numbers can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The phone number already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_RabetMasol_Tel().value
      this.RabetMasolCustomer_Tel.push(temp)
      this.get_Form_RabetMasol_Tel().setValue("")
      this.Alerify.SuccessMessage("The phone number was added to the list.")
    }
  }
  RabetMasolCustomer_Tel_Delete(id){
    this.RabetMasolCustomer_Tel.splice(id,1)
    this.Alerify.SuccessMessage("The phone number was removed from the list.")
  }

  //#endregion

  //#region Responsible technician table

  DataList_KarshnasMasol:Array<KarshnasMasol_Interface>=[]
  OnSubmit_KarshnasMasolForm(){

    var temp:KarshnasMasol_Interface=Empty_KarshnasMasol_Interface()
    temp.id=0
    temp.fname=this.get_Form_RabetMasol_FName().value
    temp.lname=this.get_Form_RabetMasol_LName().value
    temp.sex=Number(this.get_Form_RabetMasol_Sex().value)
    temp.semat=this.get_Form_RabetMasol_Semat().value
    temp.dsc=this.get_Form_RabetMasol_Dsc().value
    temp.Email=this.RabetMasolCustomer_Email
    temp.mobile=this.get_Form_RabetMasol_Mobile().value
    temp.jaygozinMiblie=this.get_Form_RabetMasol_jaygozinMiblie().value
    temp.majaziMobile = this.get_Form_RabetMasol_majaziMobile().value
    temp.type=Number(this.get_Form_RabetMasol_Type().value)
    temp.Tel=this.RabetMasolCustomer_Tel
    temp.Dakhli = this.RabetMasolCustomer_Dakheli

    if (!this.Check_KarshnasMasolForm(temp,this.KarshnasMasolForm_Edit_Id))
    {
      this.Alerify.ErrorMessage("The responsible technician information already exists in the list.")
    }
    else if(this.KarshnasMasolForm_Edit_Id==-1)
    {
      if(this.DataList_KarshnasMasol.length<20)
      {
        this.DataList_KarshnasMasol.push(temp)

        this.RabetMasolCustomer.reset();

        this.get_Form_RabetMasol_Type().setValue("0")

        this.RabetMasolCustomer_Email=[]
        this.RabetMasolCustomer_Dakheli=[]
        this.RabetMasolCustomer_Tel=[]

        this.Alerify.SuccessMessage("The responsible technician was added to the list.")
      }
      else{
        this.Alerify.ErrorMessage("No more than 20 responsible technicians can be registered.")
      }
    }

    else{
        //this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].id=this.get_Form_RabetMasol_Id().value
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].fname=temp.fname
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].lname=temp.lname
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].sex=temp.sex
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].semat=temp.semat
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].dsc=temp.dsc
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Email=temp.Email
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].mobile=temp.mobile
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].jaygozinMiblie=temp.jaygozinMiblie
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].majaziMobile=temp.majaziMobile
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Dakhli=temp.Dakhli
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Tel = temp.Tel
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].type=temp.type
        this.Alerify.SuccessMessage("The responsible technician was updated.")
        this.KarshnasMasolForm_Edit_Id = -1

        this.RabetMasolCustomer.reset();

        this.get_Form_RabetMasol_Type().setValue("0")

        this.RabetMasolCustomer_Email=[]
        this.RabetMasolCustomer_Dakheli=[]
        this.RabetMasolCustomer_Tel=[]
    }



  }

  Check_KarshnasMasolForm(Record:KarshnasMasol_Interface,index:number) {
    for (let item of this.DataList_KarshnasMasol)
    {
      if (this.DataList_KarshnasMasol.indexOf(item) == index)
      {

      }
      else if ((item.fname == Record.fname && item.lname == Record.lname) || item.mobile == Record.mobile)
      {
        return false
      }
    }
    return true
  }

  KarshnasMasolForm_Delete(id){
    this.DataList_KarshnasMasol.splice(id,1)
    this.Alerify.SuccessMessage("Deleted successfully.")
  }

  KarshnasMasolForm_Edit_Id:number=-1
  KarshnasMasolForm_Edit(id){
    this.KarshnasMasolForm_Edit_Id=id

    var temp=this.DataList_KarshnasMasol[id]
    this.RabetMasolCustomer_Dakheli=temp.Dakhli
    this.RabetMasolCustomer_Email=temp.Email
    this.RabetMasolCustomer_Tel=temp.Tel

    this.get_Form_RabetMasol_Id().setValue(temp.id)
    this.get_Form_RabetMasol_Semat().setValue(temp.semat)
    this.get_Form_RabetMasol_LName().setValue(temp.lname)
    this.get_Form_RabetMasol_FName().setValue(temp.fname)
    this.get_Form_RabetMasol_Sex().setValue(temp.sex)
    this.get_Form_RabetMasol_Dsc().setValue(temp.dsc)

    this.get_Form_RabetMasol_Mobile().setValue(temp.mobile)
    this.get_Form_RabetMasol_jaygozinMiblie().setValue(temp.jaygozinMiblie)
    this.get_Form_RabetMasol_majaziMobile().setValue(temp.majaziMobile)

    this.get_Form_RabetMasol_Type().setValue(temp.type)
  }

  KarshnasMasolForm_Edit_Cancel(){
    this.KarshnasMasolForm_Edit_Id=-1
    this.get_Form_RabetMasol_Id().setValue(0)
    this.get_Form_RabetMasol_Semat().setValue("")
    this.get_Form_RabetMasol_Dsc().setValue("")

    this.get_Form_RabetMasol_Mobile().setValue("")
    this.get_Form_RabetMasol_jaygozinMiblie().setValue("")
    this.get_Form_RabetMasol_majaziMobile().setValue("")

    this.RabetMasolCustomer_Email=[]
    this.RabetMasolCustomer_Dakheli=[]
  }

  //#endregion

  //#region Address form

  AddressCustomer:FormGroup;

  get_Form_AddressCustomer_id(){
    return this.AddressCustomer.get('id') as FormControl;
  }

  get_Form_AddressCustomer_title_id(){
    return this.AddressCustomer.get('title_id') as FormControl;
  }

  get_Form_AddressCustomer_address(){
    return this.AddressCustomer.get('address') as FormControl;
  }

  get_Form_AddressCustomer_codepost(){
    return this.AddressCustomer.get('codepost') as FormControl;
  }

  get_Form_AddressCustomer_sandoghpost(){
    return this.AddressCustomer.get('sandoghpost') as FormControl;
  }

  get_Form_AddressCustomer_pishShomareh(){
    return this.AddressCustomer.get('pishShomareh') as FormControl;
  }

  get_Form_AddressCustomer_certificateAddress(){
    return this.AddressCustomer.get('certificateAddress') as FormControl;
  }

  get_Form_AddressCustomer_Tel(){
    return this.AddressCustomer.get('Tel') as FormControl;
  }

  get_Form_AddressCustomer_Dakheli(){
    return this.AddressCustomer.get('Dakheli') as FormControl;
  }

  get_Form_AddressCustomer_Fax(){
    return this.AddressCustomer.get('Fax') as FormControl;
  }

  get_Form_AddressCustomer_Dsc(){
    return this.AddressCustomer.get('Dsc') as FormControl;
  }

  get_Form_AddressCustomer_Email(){
    return this.AddressCustomer.get('Email') as FormControl;
  }

  AddressCustomer_Tel:Array<General_Interface>=[]
  OnAdd_AddressCustomer_Tel(){

    var Exited:boolean=false
    for  (let item of this.AddressCustomer_Tel)
    {
      if(item.title==this.get_Form_AddressCustomer_Tel().value)
      {
        Exited=true;
        break
      }
    }

    if(this.AddressCustomer_Tel.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 phone numbers can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The phone number already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_AddressCustomer_Tel().value
      this.AddressCustomer_Tel.push(temp)


      this.get_Form_AddressCustomer_Tel().setValue("")
      this.Alerify.SuccessMessage("The phone number was added to the list.")
    }
  }

  AddressCustomer_Tel_Delete(id){
    this.AddressCustomer_Tel.splice(id,1)
    this.Alerify.SuccessMessage("The email address was removed from the list.")
  }

  AddressCustomer_Email:Array<General_Interface>=[]
  OnAdd_AddressCustomer_Email(){

    var Exited:boolean=false
    for  (let item of this.AddressCustomer_Email)
    {
      if(item.title==this.get_Form_AddressCustomer_Email().value)
      {
        Exited=true;
        break
      }
    }

    if(this.AddressCustomer_Email.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 email addresses can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The email address already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_AddressCustomer_Email().value
      this.AddressCustomer_Email.push(temp)


      this.get_Form_AddressCustomer_Email().setValue("")
      this.Alerify.SuccessMessage("The email address was added to the list.")
    }
  }

  AddressCustomer_Email_Delete(id){
    this.AddressCustomer_Email.splice(id,1)
    this.Alerify.SuccessMessage("The email address was removed from the list.")
  }


  //#endregion

  //#region Address

  DataList_Address_Title:Array<General_Interface>=[]

  Read_Address_Title(){
    this.Proccesing_OnSubmitForm=true
    this.AddressTitle_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.Proccesing_OnSubmitForm=false
        this.Read_Service_Province("")
        this.DataList_Address_Title=data
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_Address:Array<Address_Interface>=[]
  OnSubmit_AddressForm(){

    if(this.get_Form_AddressCustomer_title_id().value=="0")
    {
      this.Alerify.ErrorMessage("Select the address title.")
    }
    else if(this.AddressCustomer_Tel.length==0)
    {
      this.Alerify.ErrorMessage("Enter at least one phone number.")
    }
    else{

      if(this.AddressForm_Edit_Id==-1)
      {

        if(this.DataList_Address.length<100)
        {
          var temp:Address_Interface=Empty_Address_Interface()
          temp.id=0
          temp.title_id=Number(this.get_Form_AddressCustomer_title_id().value)
          temp.title = this.Find_Address_Title(temp.title_id)+''
          temp.address=this.get_Form_AddressCustomer_address().value
          temp.codepost=this.get_Form_AddressCustomer_codepost().value
          temp.sandoghpost=this.get_Form_AddressCustomer_sandoghpost().value
          temp.pishShomareh=this.get_Form_AddressCustomer_pishShomareh().value
          temp.certificateAddress=this.get_Form_AddressCustomer_certificateAddress().value
          temp.tel = this.AddressCustomer_Tel
          temp.email=this.AddressCustomer_Email
          temp.dakheli=this.get_Form_AddressCustomer_Dakheli().value
          temp.fax=this.get_Form_AddressCustomer_Fax().value
          temp.dsc=this.get_Form_AddressCustomer_Dsc().value

          this.AddressCustomer_Tel=[]
          this.AddressCustomer_Email=[]
          this.DataList_Address.push(temp)

          this.Alerify.SuccessMessage("The address was added to the list.")
        }
        else{
          this.Alerify.ErrorMessage("No more than 100 addresses can be registered.")
        }
      }
      else{

        this.DataList_Address[this.AddressForm_Edit_Id].id=this.get_Form_AddressCustomer_id().value
        this.DataList_Address[this.AddressForm_Edit_Id].title_id=Number(this.get_Form_AddressCustomer_title_id().value)
        this.DataList_Address[this.AddressForm_Edit_Id].title=this.Find_Address_Title(this.DataList_Address[this.AddressForm_Edit_Id].title_id)+''
        this.DataList_Address[this.AddressForm_Edit_Id].address=this.get_Form_AddressCustomer_address().value
        this.DataList_Address[this.AddressForm_Edit_Id].codepost=this.get_Form_AddressCustomer_codepost().value
        this.DataList_Address[this.AddressForm_Edit_Id].sandoghpost=this.get_Form_AddressCustomer_sandoghpost().value
        this.DataList_Address[this.AddressForm_Edit_Id].certificateAddress=this.get_Form_AddressCustomer_certificateAddress().value
        this.DataList_Address[this.AddressForm_Edit_Id].pishShomareh=this.get_Form_AddressCustomer_pishShomareh().value
        this.DataList_Address[this.AddressForm_Edit_Id].tel = this.AddressCustomer_Tel
        this.DataList_Address[this.AddressForm_Edit_Id].email = this.AddressCustomer_Email

        this.DataList_Address[this.AddressForm_Edit_Id].dakheli=this.get_Form_AddressCustomer_Dakheli().value
        this.DataList_Address[this.AddressForm_Edit_Id].fax=this.get_Form_AddressCustomer_Fax().value
        this.DataList_Address[this.AddressForm_Edit_Id].dsc = this.get_Form_AddressCustomer_Dsc().value

        this.AddressCustomer_Email=[]
        this.AddressCustomer_Tel=[]

        this.Alerify.SuccessMessage("The address was updated.")
        this.AddressForm_Edit_Id=-1
      }

      this.AddressCustomer.reset();
      this.get_Form_AddressCustomer_title_id().setValue("0")
    }
  }

  AddressForm_Delete(id){
    this.DataList_Address.splice(id,1)
    this.Alerify.SuccessMessage("Deleted successfully.")
  }

  Find_Address_Title(id:number)
  {
    for(let item of this.DataList_Address_Title)
    {
      if(item.id==id)
      {
        return item.title
      }
    }
    return ""
  }

  AddressForm_Edit_Id:number=-1
  AddressForm_Edit(id){
    this.AddressForm_Edit_Id=id

    var temp=this.DataList_Address[id]

    this.get_Form_AddressCustomer_id().setValue(temp.id)
    this.get_Form_AddressCustomer_title_id().setValue(temp.title_id)
    this.get_Form_AddressCustomer_address().setValue(temp.address)
    this.get_Form_AddressCustomer_codepost().setValue(temp.codepost)
    this.get_Form_AddressCustomer_sandoghpost().setValue(temp.sandoghpost)
    this.get_Form_AddressCustomer_pishShomareh().setValue(temp.pishShomareh)
    this.get_Form_AddressCustomer_certificateAddress().setValue(temp.certificateAddress)

    this.get_Form_AddressCustomer_Dakheli().setValue(temp.dakheli)
    this.get_Form_AddressCustomer_Fax().setValue(temp.fax)
    this.get_Form_AddressCustomer_Dsc().setValue(temp.dsc)

    this.AddressCustomer_Tel = temp.tel
    this.AddressCustomer_Email=temp.email
  }

  AddressForm_Edit_Cancel(){
    this.AddressForm_Edit_Id=-1
    this.AddressCustomer.reset();
  }

  //#endregion

  Proccesing_OnSubmitForm:boolean=false
  OnSubmitForm(){

    var Karshnas_Masol_Mobile:number=-1
    var Karshnas_Masol_Email:number=-1
    for(let item of this.DataList_KarshnasMasol)
    {
      if(!item.mobile && this.get_Form_Foreign().value=='0')
      {
        Karshnas_Masol_Mobile=this.DataList_KarshnasMasol.indexOf(item)
        break
      }

      if(item.Email.length == 0 && this.get_Form_Foreign().value=='1')
      {
        Karshnas_Masol_Email=this.DataList_KarshnasMasol.indexOf(item)
        break
      }
    }



    if(this.get_Form_CityId().value=="0"){
      this.Alerify.ErrorMessage("Select the city.")
    }
    else if(Karshnas_Masol_Mobile>-1){
      this.Alerify.ErrorMessage("Enter the technician mobile number in row "+(Karshnas_Masol_Mobile+1)+".")
    }
    else if(Karshnas_Masol_Email>-1){
      this.Alerify.ErrorMessage("Enter the technician email in row "+(Karshnas_Masol_Email+1)+".")
    }
    else if(this.RabetMasolCustomer_FeildActivity.length==0)
    {
      this.Alerify.ErrorMessage("Select at least one field of activity.")
    }
    else if (this.DataList_KarshnasMasol.length==0)
    {
      this.Alerify.ErrorMessage("Select at least one calibration representative.")
    }

    else{


      var tempFeild_Activity:Array<number>=[]
      for(let item of this.RabetMasolCustomer_FeildActivity)
      {
        tempFeild_Activity.push(item.id)
      }


      this.Proccesing_OnSubmitForm=true
      var CustomerRecord:Customer_Interface=Empty_Customer_Interface()
      CustomerRecord.id=this.Edit_Customer_Record.id

      CustomerRecord.city_id=Number(this.get_Form_CityId().value)
      //CustomerRecord.feildActivity_id=Number(this.get_Form_FeildActivity().value)
      CustomerRecord.name=this.get_Form_Name().value
      CustomerRecord.shenasehMeli=this.get_Form_ShenasehMeli().value
      CustomerRecord.shomarehSabt=this.get_Form_ShomarehSabt().value
      CustomerRecord.codeEghtesadi=this.get_Form_CodeEghtesadi().value
      CustomerRecord.codeMeli=this.get_Form_CodeMeli().value
      CustomerRecord.modirAmelName=this.get_Form_ModirAmelName().value
      CustomerRecord.modirAmelMobile=this.get_Form_ModirAmelMobile().value
      CustomerRecord.modirAmelTel=this.get_Form_ModirAmelTel().value
      CustomerRecord.modirAmelDakheli=this.get_Form_ModirAmelDakheli().value
      CustomerRecord.modirAmelEmail=this.get_Form_ModirAmelEmail().value
      CustomerRecord.foreign=this.get_Form_Foreign().value=='1'

      this.Customer_Service.EditCustomer(
        CustomerRecord,
        this.DataList_KarshnasMasol,
        this.DataList_Address,
        tempFeild_Activity,
        this.Token).subscribe(
        data=>{
          this.Proccesing_OnSubmitForm=false
          if(data.id==-1)
          {
            this.Alerify.ErrorMessage("The national identifier is already registered for customer "+data.name+".")
          }
          else if(data.id==-3)
          {
            this.Alerify.ErrorMessage("Enter the national identifier.")
          }
          else{
            this.Alerify.SuccessMessage("Information saved successfully.")


          }

        }
      )
    }

  }


}
